<template>
  <div id="app">

    <b-navbar toggleable="md" type="light" variant="transparent" fixed="top" class="hide-mobile" id="top-nav">
      <b-navbar-toggle target="nav_collapse"><span class="menu-text">Menu</span><icon name="bars" v-show="!menuOpen"/><icon name="times" v-show="menuOpen"/></b-navbar-toggle>
      <b-navbar-brand to="/" @click="menuOpen = false">
        <img width="115px" height="35px" class="" src="/img/BubbloPlus_Logo_RGB_Vihrea.svg" alt="Bubblo+-logo" />
      </b-navbar-brand>
      <b-navbar-nav v-if="!isLoggedIn">
        <b-nav-item to="/welcome/sign-in" @click="menuOpen = false">{{$t('nav:sign-in')}}</b-nav-item>
        <b-nav-item to="/sign-up"  @click="menuOpen = false">{{$t('nav:sign-up')}}</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav v-if="isLoggedIn">
        <b-nav-item to="/personal/survey" @click="menuOpen = false" class="text-right text-md-center badge-count" :data-count="numberOfPendingQuestions ? numberOfPendingQuestions : null"><img src="/img/icons/BubbloPlus_Ikonit_RGB_Oppaasi_1.svg" alt="Oppaasi/Guides" class="fa-icon" /><span class="nav-text">{{$t('nav:guide')}}</span></b-nav-item>
        <b-nav-item v-if="hasCapability('challenges')" :to="{name: 'Challenges'}" @click="menuOpen = false" class="text-right text-md-center"><img src="/img/icons/BubbloPlus_Ikonit_RGB_Haasteet_1.svg" alt="Haasteet/Challenges" class="fa-icon" /><span class="nav-text">{{$t('nav:challenges')}}</span></b-nav-item>
        <b-nav-item to="/personal/results" @click="menuOpen = false" class="text-right text-md-center"><img src="/img/icons/BubbloPlus_Ikonit_RGB_Sina_1.svg" alt="Sinä/You" class="fa-icon" /><span class="nav-text">{{$t('nav:you')}}</span></b-nav-item>
        <b-nav-item to="/team/reports" @click="menuOpen = false" class="text-right text-md-center"><img src="/img/icons/BubbloPlus_Ikonit_RGB_Tiimi_1.svg" alt="Tiimi/Team" class="fa-icon" /><span class="nav-text">{{$t('nav:team')}}</span></b-nav-item>
        <b-nav-item v-if="hasCapability('journal')" id="main-nav_journal" to="/personal/journal" @click="menuOpen = false" class="text-right text-md-center"><img src="/img/icons/BubbloPlus_Ikonit_RGB_Muistikirja_1.svg" alt="Muistikirja/Journal" class="fa-icon" /><span class="nav-text">{{$t('nav:journal')}}</span></b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item @click="menuOpen = !menuOpen" class="app-nav-item text-center"><img src="/img/icons/BubbloPlus_Ikonit_RGB_Asetukset_1.svg" alt="Asetukset/Options" class="fa-icon" /><span class="nav-text">{{ $t('nav:settings') }}</span></b-nav-item>
      </b-navbar-nav>

    </b-navbar>
    <b-navbar class="app-nav fixed-bottom">
      <b-nav-item v-if="isLoggedIn" to="/personal/survey" @click="menuOpen = false" class="app-nav-item text-center badge-count" :data-count="numberOfPendingQuestions ? numberOfPendingQuestions : null"><img src="/img/icons/BubbloPlus_Ikonit_RGB_Oppaasi_1.svg" alt="Oppaasi/Guides" class="fa-icon" /><span class="nav-text">{{$t('nav:guide')}}</span></b-nav-item>
      <b-nav-item v-if="isLoggedIn && hasCapability('challenges')" :to="{name: 'Challenges'}" @click="menuOpen = false" class="app-nav-item text-center"><img src="/img/icons/BubbloPlus_Ikonit_RGB_Haasteet_1.svg" alt="Haasteet/Challenges" class="fa-icon" /><span class="nav-text">{{$t('nav:challenges')}}</span></b-nav-item>
      <b-nav-item v-if="isLoggedIn" to="/personal/results" @click="menuOpen = false" class="app-nav-item text-center"><img src="/img/icons/BubbloPlus_Ikonit_RGB_Sina_1.svg" alt="Sinä/You" class="fa-icon" /><span class="nav-text">{{$t('nav:you')}}</span></b-nav-item>
      <b-nav-item v-if="isLoggedIn" to="/team/reports" @click="menuOpen = false" class="app-nav-item text-center"><img src="/img/icons/BubbloPlus_Ikonit_RGB_Tiimi_1.svg" alt="Tiimi/Team" class="fa-icon" /><span class="nav-text">{{$t('nav:team')}}</span></b-nav-item>
      <b-nav-item v-if="isLoggedIn && hasCapability('journal')" to="/personal/journal" @click="menuOpen = false" class="app-nav-item text-center"><img src="/img/icons/BubbloPlus_Ikonit_RGB_Muistikirja_1.svg" alt="Muistikirja/Journal" class="fa-icon" /><span class="nav-text">{{$t('nav:journal')}}</span></b-nav-item>
      <b-nav-item @click="menuOpen = !menuOpen" class="app-nav-item text-center"><img src="/img/icons/BubbloPlus_Ikonit_RGB_Asetukset_1.svg" alt="Asetukset/Options" class="fa-icon" /><span class="nav-text">{{ $t('nav:settings') }}</span></b-nav-item>
    </b-navbar>
    <transition name="view" mode="out-in">
      <router-view></router-view>
    </transition>
    <b-collapse id="nav_collapse" v-model="menuOpen">
      <b-navbar-nav v-if="!isLoggedIn">
        <b-nav-item class="text-right d-lg-none" to="/welcome/sign-in" @click="menuOpen = false">{{$t('nav:sign-in')}}</b-nav-item>
        <b-nav-item class="text-right d-lg-none" to="/sign-up"  @click="menuOpen = false">{{$t('nav:sign-up')}}</b-nav-item>
      </b-navbar-nav>
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item to="/profile" @click="menuOpen = false" class="text-right" v-if="isLoggedIn">{{$t('nav:profile')}}</b-nav-item>
        <b-nav-item to="/account/people" @click="menuOpen = false" class="text-right" v-if="isOwner">{{$t('nav:account')}}</b-nav-item>
        <b-nav-item @click="logout" class="text-right" v-if="isLoggedIn" >{{$t('nav:logout')}}</b-nav-item>
        <b-nav-item-dropdown dropup class="text-right d-lg-none" :text="$t('default:'+$i18n.i18next.language)" right>
          <b-dropdown-item v-on:click="changeLanguage('en')">{{$t('default:en')}}</b-dropdown-item>
          <b-dropdown-item v-on:click="changeLanguage('fi')">{{$t('default:fi')}}</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown class="text-right d-none d-lg-block" :text="$t('default:'+$i18n.i18next.language)" right>
          <b-dropdown-item v-on:click="changeLanguage('en')">{{$t('default:en')}}</b-dropdown-item>
          <b-dropdown-item v-on:click="changeLanguage('fi')">{{$t('default:fi')}}</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item @click="showTos">{{$t('nav:tos')}}</b-nav-item>
        <b-nav-item @click="showPp">{{$t('nav:pp')}}</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
    <transition name="fadeout">
      <splash-loading v-if="$store.state.translationsLoading"/>
    </transition>
    <vue-progress-bar></vue-progress-bar>
    <custom-modal :title="$t('tos:tos-main-title')" :show="tosShown" @close="hideTos"><terms-of-service /></custom-modal>
    <custom-modal :title="$t('pp:pp-main-title1')" :show="ppShown" @close="hidePp"><privacy-policy /></custom-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SplashLoading from './components/common/splashloading/SplashLoading'
import CustomModal from './components/embeddable/CustomModal'
import TermsOfService from './components/landing/TermsOfService/TermsOfService'
import PrivacyPolicy from './components/landing/PrivacyPolicy/PrivacyPolicy'
import analytics from './analytics'

export default {
  name: 'app',
  components: {
    SplashLoading,
    CustomModal,
    TermsOfService,
    PrivacyPolicy
  },
  data () {
    return {
      menuOpen: false,
      ppShown: false,
      tosShown: false
    }
  },
  methods: {
    showTos () {
      this.tosShown = true
      this.menuOpen = false
    },
    hideTos () {
      this.tosShown = false
    },
    showPp () {
      this.ppShown = true
      this.menuOpen = false
    },
    hidePp () {
      this.ppShown = false
    },
    hasCapability (capability) {
      if (this.$store.state.account.accountSetup && this.$store.state.account.accountSetup.capabilities[capability] === true) {
        return true
      }
      return false
    },
    changeLanguage (lang) {
      if (this.$i18n.i18next.language !== lang) {
        this.$store.dispatch('setTranslationsLoading', true)
        this.$i18n.i18next.changeLanguage(lang)
      }
      this.menuOpen = false
    },
    logout () {
      analytics.track('logout')
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/welcome/sign-in')
        this.menuOpen = false
      })
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'isLoginPending', 'numberOfPendingQuestions', 'isOwner'])
  }
}
</script>

<style lang="scss">
$cyan: #1ea0c2;
$green: #1db76f;
$primary: #377771; //#20a8cc;
$secondary: #4ce0b3;
$white: #fafafa;
$input-border-color: $primary;
$nav-tabs-link-active-color: $primary;
$navbar-light-active-color: #377771; //#17B5CF; //white; // darken($primary, 0%);
$navbar-light-hover-color: #377771; //#17B5CF;// white; // darken($primary, 0%);
$navbar-light-color: #377771; //#17B5CF; //white; // lighten($primary, 20%);
$navbar-nav-link-padding-x: 24px;
$navbar-padding-y: 1rem;

.btn-success {
  background-color: $primary !important;
  border-color: $primary !important;
  color: $white;
}

.btn-success:hover {
  border-color: $secondary !important;
  // background-color: $secondary !important;
}

.btn-light .btn-secondary {
  background-color: $white  !important;
}

.btn-light:hover, .btn-secondary:hover {
  border-color: $primary !important;
}

.progress-bar {
  background-color: $primary !important;
}

#top-nav .navbar-nav {
  height: 50px;
  .nav-item {
    .nav-link {
      .fa-icon {
        display: inline-block !important;
        // max-width: 1em;
      }
      .nav-text {
        display: inline;
        font-size: 1rem;
        color: #377771;
      }
    }
  }
}

.navbar {
  box-shadow: 0 0 6px rgba(black, 0.05);
  flex-direction: row-reverse;
  // Small devices (landscape phones, 576px and up)
  @media (min-width: 576px) {
  }

  // Medium devices (tablets, 768px and up)
  @media (min-width: 768px) { }

  // Large devices (desktops, 992px and up)
  @media (min-width: 992px) {
    flex-direction: row;
  }

  // Extra large devices (large desktops, 1200px and up)
  @media (min-width: 1200px) {  }

  &.bg-transparent {
    background: #fff !important;// #17B5CF !important; // rgba(lighten($primary, 2%), 1) !important; // 17B5CF
  }
  padding: 0!important;

  .nav-item {
    .nav-link {
      font-size: 12px;
      font-weight: bold;
      padding-top: 12px;
      padding-bottom: 12px;

      padding-left: 7px;
      padding-right: 7px;
      font-size: 10px;
      // Medium devices (tablets, 768px and up)
      @media (min-width: 992px) {
        font-size: 12px;
        padding-right: 0;
      }

      &.active {
        background: white; //rgba(black, 0.1);
      }
      &:hover:not(.active) {
        // background: white; //rgba(black, 0.05);
      }

    }
  }

  .navbar-brand {
    font-size: 0;
    padding: 0;
    margin: 5px 5px;
  }

  .navbar-collapse {
    // height: 100%;
    padding-top: 24px;
    @media (min-width: 992px) {
      padding-top: 0;
    }
    .ml-auto {
      margin-top: 24px;
      @media (min-width: 992px) {
      margin-top: 0;
      }
    }

  }
  .navbar-toggler {
    outline: none;
    padding-right: 12px;
    .menu-text {
      font-size: 12px;
      line-height: 24px;
      text-transform: uppercase;
      font-weight: bold;
      margin-right: 12px;
      display: inline-block;
    }
    .fa-icon {
      width: 24px;
    }
  }

}

.hide-mobile {
  display: none !important;
  @media (min-width: 992px) {
    display: flex !important;
  }
}

#nav_collapse {
  z-index: 1;
  position: fixed;
  opacity: 0;
  transition: all 0s ease;
  // transform: translateY(100%);
  background: rgba(darken($primary, 5%),0.95);
  top: 0;
  left: 0;
  bottom: 60px;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-top: 24px;
  padding-bottom: 24px;
  min-height: calc(100% - 60px);

  @media (min-width: 992px) {
    justify-content: flex-start;
    bottom: 0;
    top: 50px;
    &.collapse.show ul {
      // padding-top: 1em;
    }
  }
  .nav-item {
    padding: 12px 24px;
    .nav-link {
      color: white;
      text-align: right;
    }
  }
  // height: 100%;
  &.collapsing {
    transition: all 0 ease;
    // transform: translateY(100%);
    // height: 100%;
    opacity: 0;
  }
  &.show {
    transition: all 250ms ease;
    // transform: translateY(0%);
    opacity: 1;
  }
}

.app-nav {
  box-shadow: 0 0 12px rgba(black, 0.05);
  border-top: 1px solid #f0f0f0;
  height: 60px;
  background: #f9f9f9;
  display: flex !important;
  flex-direction: row !important;
  // visibility: visible;
  @media (min-width: 992px) {
    display: none !important;
    // visibility: hidden;
  }
  justify-content: center !important;
  align-items: center !important;
  .app-nav-item {
    display: block;
    flex-grow: 1;
  }
  .app-nav-item .nav-link {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // padding: 0 24px !important;
    margin: 0;
    color: $navbar-light-color;
    text-align: center;
    height: 60px;
    cursor: pointer;
    &.active {
      background: white;
    }
  }
  .nav-text {
    display: block;
    margin: 0;
    margin-top: 3px;
    font-size: 11px;
    // @media (min-width: 768px) {
    //   margin-top: 6px;
    //   margin-right: 0;
    //   display: block;
    // }
  }
  .fa-icon {
    float: none;
  }
}

.navbar-light .navbar-toggler {
  border: 0;
}

.nav-tabs .nav-link {
  font-weight: light;
  letter-spacing: 0.025rem;
  font-size: 15px;
  color: darken($primary, 20%);
}

.navbar-nav .nav-item {
  font-weight: light;
  letter-spacing: 0.025rem;
  font-size: 15px;
  .nav-link {
    color: darken($primary, 20%);
    line-height: 24px;
    &.active {
    }
    .nav-text {
      vertical-align: middle;
      margin-left: 2px;
    }
  }
}

@import '~bootstrap/scss/bootstrap';
@import '~bootstrap-vue/dist/bootstrap-vue';

html {
  height: 100%;
}

._backround {
  background-repeat: no-repeat;

  // background-color: $primary; // #20a8cc;
  // background-color: #0073BB; // #20a8cc;
  // background-repeat: no-repeat;
  // background-image: linear-gradient(to top,#00A2AC, #0073BB);
  // background-image: radial-gradient(circle at bottom right,#00D6D6, #20a8cc);
  background-image: url('/img/BubbloPlus_vihrea_Background.jpg');
  background-attachment: fixed, fixed;
  background-size: cover;
  background-position: center;
}

body {
  // height: 100%;
  @extend ._backround;
}

#app {
//  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-family: 'Lato', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
//  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding-top: 0px;
  padding-bottom: 60px;
  @media (min-width: 992px) {
    padding-bottom: 0px;
    padding-top: 50px;
  }
  height: 100%;
}

.view-enter-active,
.view-leave-active {
  transition: opacity 200ms;
}

.view-enter,
.view-leave-to {
  opacity: 0;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.fadeout-enter-active {
  transition: opacity 0s;
}
.fadeout-leave-active {
  transition: opacity .5s;
}
.fadeout-enter, .fadeout-leave-to {
  opacity: 0;
}

.sub-view-enter-active,
.sub-view-leave-active {
  transition: opacity 200ms;
}

.sub-view-enter,
.sub-view-leave-to {
  opacity: 0;
}

button {
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
  }
}

.fa-icon {
  // width: auto;
  height: 1.2rem; /* or any other relative font sizes */
  vertical-align: middle;
  /* You would have to include the following two lines to make this work in Safari */
  max-width: 100%;
  max-height: 100%;
}

.panel {
  box-shadow: 0 0.2rem 0.5rem rgba(black, 0.2);
  background: white;
}

.panel--tab {
  border: 1px solid $nav-tabs-border-color;
  border-top: none;
  padding: 2rem;
  background: white;
}

.panel-light {
  padding: 2rem 1rem;
  margin: 2rem auto;
  background: rgba(black, 0.1);
  color: white;
  // text-shadow: 0 1px 4px rgba(darken($primary, 5%), 1);
}

.panel--invisible {
  padding: 1rem 1rem;
  margin: 2rem auto;
  color: white;
  a {
    text-decoration: underline;
    color: lighten($primary, 35%);
  }
}

@keyframes buttonLoading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes buttonLoadingAppear {
  0% {
    opacity: 0;
    right: 0;
  }
  100% {
    right: 0.75em;
  }
}

.loading {
  position: relative;
  padding-right: 2.5em;
//  padding-left: 1.25em;
}

.loading:after {
    animation: buttonLoading 0.7s linear infinite, buttonLoadingAppear 0.5s ease-out;
    content: '';
    display: block;
    position: absolute;
    right: 0.75em;
    top: 50%;
    margin-top: -0.5em;
    width: 1em;
    height: 1em;
    border-radius: 1em;
    border-left: 1px solid rgba(white, 0.2);
    border-top: 1px solid rgba(white, 0.2);
    border-right: 1px solid white;
    border-bottom: 1px solid white;
}

@keyframes loadingScreenAnimation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes loadingScreenAnimationAppear {
  0% {
    opacity: 0;
    right: 0;
  }
  100% {
    right: 0.75em;
  }
}

.loadingScreen {
  background: rgba(black, 0.5);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
}

.loadingScreen:after {
    $_loadingScreenSpinnerSize: 5em;
    animation: loadingScreenAnimation 0.7s linear infinite, loadingScreenAnimationAppear 0.5s ease-out;
    content: '';
    display: block;
    position: relative;
    left: calc(50% - #{$_loadingScreenSpinnerSize/2});
    top: $_loadingScreenSpinnerSize*3;
    width: $_loadingScreenSpinnerSize;
    height: $_loadingScreenSpinnerSize;
    border-radius: $_loadingScreenSpinnerSize;
    border-left: 3px solid rgba(white, 0.2);
    border-top: 3px solid rgba(white, 0.2);
    border-right: 3px solid white;
    border-bottom: 3px solid white;
}

.badge-count[data-count] {
  $badge_size: 9px;
  position: relative;
  &:after{
    content: attr(data-count);
    position: absolute;
    right: $badge_size*1;
    // margin-left: $badge_size*0.75;
    top: $badge_size*0.65;
    font-size: $badge_size;
    padding: $badge_size*0.25 $badge_size*0.5;
    line-height: $badge_size;
    border-radius: $badge_size;
    color: white;
    background: lighten($green, 10%);
    text-align:center;
    min-width: $badge_size*1.5;
    font-weight:bold;
    // border: 1px solid $primary;
  }
}

// @media (min-width: 576px) {
//     .card-columns {
//         column-count: 1;
//     }
// }

// @media (min-width: 768px) {
//     .card-columns {
//         column-count: 1;
//     }
// }

// @media (min-width: 992px) {
//     .card-columns {
//         column-count: 2;
//     }
// }

// @media (min-width: 1200px) {
//     .card-columns {
//         column-count: 3;
//     }
// }
// .card-columns {
//   column-gap: 24px;
//   .card {
//     margin-bottom: 24px;
//   }
// }

.insight-card {
  border: none;
  border-radius: 6px;
  box-shadow: 0 3px 6px rgba(0,0,0,0.12);
  height: 100%;
  // background: rgba(white, 0.9) !important;
  .card-img-top {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
}

.insight-gem-card {
  @extend .card;
  margin-bottom: 1rem;
  cursor: pointer;
  box-shadow: 0px 1px 3px rgba(black, 0.12);
  border: none;
  transition: transform 100ms ease-in-out, box-shadow 200ms ease-in-out, opacity 100ms ease-in-out;
  &:hover:not(.disabled):not(.selected), &:active:not(.disabled):not(.selected) {
    box-shadow: 0px 3px 6px rgba(black, 0.18);
    transform: scale(1.01);
  }
  &.disabled {
    opacity: 0.6;
    cursor: auto;
  }
  &.selected {
    transform: scale(1.01);
    border: 1px solid #68d3e6;
    cursor: auto;
  }
  .card-body {
    padding: none;
    margin: none;
    display: flex;
    flex-direction: rows;
    align-items: start;
    .gem-icon {
      flex-shrink: 0;
      flex-grow: 0;
      width: 32px;
      height: 32px;
      margin-right: 1rem;
    }
    .insight-title {
      font-size: 1rem;
      font-weight: normal;
      color: #2094a9;
    }
  }
}

.overlayed {
  filter: blur(3px);
  opacity: 0.2;
}

$_modal_width: 992px;

.subview-overlay {
  overflow: hidden;
  overflow-y: scroll;
  position: fixed;
  top: 12px*3.5;
  left: 0;
  right: 0;
  bottom: 60px;
  box-shadow: 0 3px 6px rgba(black, 0.24);

  @media (min-width: 992px) {
    top: 48px*2 + 12px*3.5;
    bottom: 48px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: $_modal_width;
  }
  background: white; //rgba(darken(#17B5CF,20%), 0.7); //white;
}

.full-overlay {

  @extend ._backround;
  background-color: #e3f5f9;
  background-image: url('/img/BubbloPlus_vihrea_Background.jpg'), radial-gradient(circle at center center,rgba(white,0.8), rgba(white,0.6)), radial-gradient(circle at bottom right,#b7e3ef, #9bdbec);

  overflow: hidden;
  overflow-y: hidden;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // bottom: 60px;
  z-index: 1031;

  // @media (min-width: 768px) {
  //   top: 50px;
  //   bottom: 0;
  //   left: 0;
  //   right: 0;
  // }

  display: flex;
  flex-direction: column;

  .overlay-header {
    // background: #ebfbff;
    width: 100%;
    max-width: $_modal_width;
    margin: auto;
  }

  .overlay-content {
    background: #E2F3F6;
    background: white;
    // padding: 3em 0;
    flex-grow: 1;
    overflow: hidden;
    overflow-y: auto;
    width: 100%;
    max-width: $_modal_width;
    margin: auto;
    border-radius: 0;
    // box-shadow: 0 6px 18px rgba(black, 0.15);
    // margin-top: 50px;
    // margin-bottom: 50px;

    @media (min-width: 576px) { }
    @media (min-width: 768px) { }
    @media (min-width: 992px) {
      border-radius: 12px;
    }
    @media (min-width: 1200px) {  }

  }

  .overlay-footer {
    // background: #ebfbff;
    // padding-top: 1em;
    // min-height: 80px;
    width: 100%;
    max-width: $_modal_width;
    margin: auto;
  }
}

.subnav {
  height: 12px*3.5;
  background: #f9f9f9; //#45BCD6;
  color: #17B5CF;
  position: fixed;
  top: 0;
  @media (min-width: 992px) {
    top: 48*2px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: $_modal_width;
  }
  left: 0;
  right: 0;
  .btn.disabled {
    opacity: 0.25;
  }
  .subnav-progress {
    line-height: 42px;
    vertical-align: middle;
    .item {
      background: #17B5CF;
      width: 12px;
      height: 12px;
      display: inline-block;
      margin: 0 3px;
      border-radius: 6px;
      opacity: 0.33;
      &.active {
        opacity: 1;
      }
    }
  }
}

.overlay-subnav {
  // height: 12px*3.5;
  // background: #f9f9f9; //#45BCD6;
  color: #17B5CF;
  .btn.disabled {
    opacity: 0.25;
  }
  white-space: nowrap;
  .subnav-progress {
    line-height: 49px;
    vertical-align: middle;
    .item {
      background: #ed6a5e;
      width: 16px;
      height: 16px;
      display: inline-block;
      margin: 0 3px;
      border-radius: 8px;
      opacity: 0.5;
      &.active {
        opacity: 1;
      }
    }
  }
}

.hero-image {
    // height: 50%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    padding: 5% 48px;
}

.hero-text {
  text-align: center;
  display: flex;
  flex-direction: column;
  color: white;
}

// REPORT STYLES

.overall-score {
  text-align: left;
  line-height: 1;
  .--value {
    font-size: 3rem;
    font-weight: 300;
  }
  .--scale {
    color: #888;
    font-size: 1rem;
  }
}

.trend-indicator {
  text-align: left;
  line-height: 1;
  font-size: 3rem;
  .--icon {
    display: inline-block;
    font-size: 3rem;
    line-height: 1rem;
  }
  &.up {
    vertical-align: top;
    .--icon {
      color: #377771;
    }
  }
  &.down {
    vertical-align: bottom;
    .--icon {
      color: #ed6a5d;
    }
  }
  &.flat {
    .--icon {
      color: #8ed7da;
    }
  }
  .--magnitude {
    display: inline-block;
    line-height: 1;
    .--value {
//      font-size: 1rem;
      font-size: 3rem;
      font-weight: 300;
      vertical-align: top;
    }
    .--scale {
      color: #888;
      font-size: 1rem;
    }
    .--percent {
      font-size: 1rem;
      color: #888;
    }
  }
}
.--reference-point {
  display: inline-block;
  font-size: 0.8rem;
  color: #888;
  margin-bottom: 1em;
}

@keyframes grow {
    from {
      transform: scaleX(0);
    }
    to {
      transform: scaleX(1);

    }
}

.animated-bar {
  background: #f3f3f3;
  padding: 3px;
  margin-top: 12px;
  border-radius: 6px;
  position: relative;
  .meter {
    height: 6px;
    width: 0;
    border-radius: 6px;
    transform-origin: left;
    &.activated {
      animation: 1s ease 0s 1 grow;
    }
  }
  &.has-negative {
    display: flex;
    align-items: center;
    justify-items: center;
    flex-direction: column;
    // justify-content: space-around;
    &::after {
      content: '';
      position: absolute;
      display: inline-block;
      border-left: 1px solid #666;
      // height: 12px;
      width: 1px;
      left: 50%;
      top: 0;
      bottom: 0;
    }
    .meter:not(.negative) {
      border-radius: 0 6px 6px 0;
      align-self: flex-start;
    }
    .meter.negative {
      transform-origin: right;
      align-self: flex-end;
      margin-right: 50%;
      border-radius: 6px 0 0 6px;
    }
  }
}

.tidbit {
  font-size: 0.75rem;
  color: #888;
}

h1.info-headline {
  // text-transform: uppercase;
  font-weight: 700;
  font-size: 1.5rem;

  margin-bottom: 1rem;

  @media (min-width: 575px) {
    font-size: 2rem;
  }
  @media (min-width: 900px) {
    font-size: 2.5rem;
  }
}

h2.info-headline {
  text-transform: none;
  font-weight: 700;
  font-size: 1.3rem;

  margin-bottom: 1rem;

  @media (min-width: 575px) {
    font-size: 1.6rem;
  }
  @media (min-width: 900px) {
    font-size: 1.9rem;
  }
}

h3.feedback-title {
  font-size: 1.25rem;
}

.zoom-enter-active,
.zoom-leave-active {
  animation-duration: 0.25s;
  animation-fill-mode: both;
  animation-name: zoom;
}

.zoom-leave-active {
  animation-direction: reverse;
}

@keyframes zoom {
  from {
    opacity: 0;
    // transform: translateX(2em);
    // transform: scale3d(0.1, 0.1, 0.1);
  }

  100% {
    opacity: 1;
  }
}

// CONVERSATIONAL UI ELEMENTS

.bubble {
  font-size: 14px;
  @media (min-width: 575px) {
    font-size: 1em;
  }
  // @media (min-width: 900px) {
  //   margin-top: 2rem;
  // }

  .message {
    display: inline-block;
    background-color: #fff;
    color: #377771;
    border-radius: 24px;
    border-top-left-radius: 0;
    box-shadow: 0 3px 6px rgba(black, 0.1);
    margin-bottom: 1rem;
    padding: 12px 18px;
    &.opener {
      font-weight: bold;
    }
  }
  .btn {
    font-size: 14px;
    margin-bottom: 12px;
    @media (min-width: 575px) {
      font-size: 1em;
      margin-bottom: 12px;
    }
    display: inline-block;
    // transition: all 0.15s ease-in-out;
    // width: 100%;
    line-height: 24px;
    border: 0;
    border-radius: 24px;
    box-shadow: 0 3px 6px rgba(black, 0.1);
    padding: 12px 18px;
    background: white;
    color: $primary;
    font-weight: bold;
    &:hover {
//      transform: scale(1.05);
      background: rgb(240, 249, 250);
      color: darken($primary, 20%);
    }
    &:disabled:not(.active) {
      color: #888;
      display: none;
    }
    &:disabled {
      opacity: 1;
    }
    &.active {
      color: black;
      border-top-right-radius: 0;
    }
    // &:last-child {
    //   border-bottom: none;
    // }
  }
}

.bubble--multiple-choice {
  @extend .bubble;
  padding-bottom: 0;
  .choices {
    width: 100%;
    text-align: right;
      // margin-top: 12px;
    // background: white;
    // border-radius: 0 0 6px 6px;
    // padding-bottom: 6px;
    .btn {
      margin-left: 12px;
      &:disabled {
        cursor: default !important;
      }
      // float: right;
      // clear: both;
    }
  }
}

.bubble--info {
  @extend .bubble;
  .message {
    // background: #ff8e87;
    background-color: #377771;
    color: #fff;
    font-style: italic;
  }
  a {
    color: #ff8e72;
  }
}

.character-counter {
  color: #ed6a5d;
  font-size: 0.8em;
  text-align: right;
  min-height: 1em;
}

// IE FIXES

.card-img-top {
  max-width: 100%;
  flex-shrink: 0;
}

</style>
